import { legacyLibrary as r, parseLegacyIconKey as t } from "./libraries/legacy.js";
const l = r.icons.map((e) => {
  const { group: o, name: a } = t(e);
  return {
    // Prefix the src with the group so that the final flat icon map has unique keys
    src: e,
    title: a.replaceAll("-", " "),
    group: o,
    tags: []
  };
});
export {
  l as localIconList
};
